// removed by extract-text-webpack-plugin
module.exports = {"backgroundLoad":"src-components-ui----BackgroundLoad-module---backgroundLoad---3i3iY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/BackgroundLoad.module.scss
// module id = 862
// module chunks = 114276838955818